export interface FrequencyLabels {
    monthly: string;
    yearly: string;
    'one-time': string;
}

export function buildFrequencyLabels(labels: {
    frequencyMonthly: string;
    frequencyYearly: string;
    frequencyOneTime: string;
}): FrequencyLabels {
    return {
        monthly: labels.frequencyMonthly,
        yearly: labels.frequencyYearly,
        'one-time': labels.frequencyOneTime,
    };
}
